export const testIds = {
  timeInput: "timeInput",
  timeInputOptionDate: "timeInputOption-date",
  timeInputOptionTime: "timeInputOption-time",
};
